import { render } from "./App.vue?vue&type=template&id=d6727d32"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d6727d32&lang=css"

import exportComponent from "F:\\Desktop\\HBX\\YCKJ\\metav-g-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__